export enum GroupChannel {
  CREATE = 'group::create',
  EDIT = 'group::patch',
  DELETE = 'group::delete',
}
